export default {
  common: {
    price: '{{currency}} {{amount}}',
    dateRange: '{{from}} - {{to}}',
    currencyJpy: 'JPY',
    suggestVisitingTime: '권장 관람 시간',
    searchIcon: '✦',
    zoomIn: '+',
    zoomOut: '−',
    back: '←'
  },
  home: {
    searchPlaceholder: '어디로 가고 싶으신가요?',
    scale800m: '도보 15분 (800m)',
    scale2km: '지하철 2개 역 이내 (2km)',
    scale5km: '지하철 5개 역 이내 (5km)',
    nearbyCount: '{{count}}곳',
    listMode: '목록 보기',
    mapMode: '지도 보기',
    exploreNearby: '주변 둘러보기',
    filterAll: '전체',
    tataGreeting:
      '안녕, 나는 tata야~\n{{city}} 여행, 근처 가볼만한 곳 추천해줄게!',
    tataGreetingFallback: '안녕, 나는 tata야\n함께 더 재미있는 곳을 찾아보자~'
  },
  search: {
    noResults: '결과가 없습니다',
    youMayLike: '좋아할 것 같아요',
    whereNext: '다음은 어디로?'
  },
  booking: {
    ticketInfo: '티켓 정보',
    viewTicket: '전자 티켓 보기',
    plan: '플랜',
    date: '참가일',
    participants: '참가 인원',
    highlights: '추천 포인트',
    openingHours: '영업 시간',
    address: '주소',
    officialSite: '공식 사이트',
    goingTo: '곧 {{title}}(으)로',
    nextStation: '다음 스팟으로'
  },
  profile: {
    backToMap: '지도로 돌아가기',
    my: '내 정보',
    tickets: '티켓',
    favourites: '즐겨찾기',
    exploreMore: '더 둘러보기',
    viewMap: '지도 보기'
  },
  bookmarks: {
    myBookmarks: '내 즐겨찾기',
    empty: '즐겨찾기가 없습니다'
  },
  tickets: {
    myTickets: '내 티켓',
    quantity: '수량',
    viewTicket: '티켓 보기',
    empty: '티켓이 없습니다'
  },
  voucher: {
    scanCode: 'QR코드를 스캔해 주세요',
    useEticket: '탭하여 e티켓 사용하기',
    ticketDetail: '티켓 상세',
    notification: '자세한 정보 및 수동 교환은 「티켓 상세」를 눌러 주세요',
    orderId: '주문 ID: {{id}}'
  },
  poi: {
    highlights: '추천 포인트',
    openingHours: '영업 시간',
    address: '주소',
    officialWebsite: '공식 사이트',
    adultTicket: '성인 티켓',
    priceFrom: '{{price}}부터',
    buyTicket: '티켓 구매',
    viewDetails: '상세 보기',
    freeAdmission: '무료 입장',
    ratingCount: '{{n}}개 평가',
    star: '★',
    clock: '🕐',
    nearbyRecommend: '주변 추천',
    recentEvents: '최근 이벤트',
    distanceTo: '{{name}}에서 {{distance}}',
    aiGenerated: 'AI가 생성한 콘텐츠',
    goingTo: '곧 도착',
    categories: {
      experience: '체험',
      nature: '자연',
      attraction: '관광 명소',
      gourmet: '미식',
      shopping: '쇼핑'
    }
  },
  event: {
    tag: '이벤트',
    period: '행사 기간',
    duration: '소요 시간',
    officialWebsite: '이벤트 공식 사이트'
  }
};
